import { useEffect, useState } from "react";
import { api, fmtDateTime } from "@/lib/api";

export default function Activity() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/activity?limit=300").then((r) => setItems(r.data)).catch(() => {}); }, []);

  return (
    <div className="space-y-5" data-testid="activity-page">
      <div>
        <div className="label-mini">Audit Trail · Append-Only</div>
        <h1 className="text-3xl font-bold tracking-tight mt-1">Activity Log</h1>
      </div>
      <div className="card-sharp overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-zinc-50">
            <tr className="text-left">
              <th className="label-mini px-4 py-3">Timestamp</th>
              <th className="label-mini px-4 py-3">User</th>
              <th className="label-mini px-4 py-3">Action</th>
              <th className="label-mini px-4 py-3">Entity</th>
              <th className="label-mini px-4 py-3">Description</th>
            </tr>
          </thead>
          <tbody>
            {items.map((a) => (
              <tr key={a.id} className="border-t border-zinc-100" data-testid={`activity-row-${a.id}`}>
                <td className="px-4 py-3 text-xs font-mono whitespace-nowrap">{fmtDateTime(a.timestamp)}</td>
                <td className="px-4 py-3 text-xs">
                  <div className="font-medium">{a.user_name}</div>
                  <div className="text-zinc-500">{(a.user_roles || []).join(", ")}</div>
                </td>
                <td className="px-4 py-3">
                  <span className="status-badge" style={{ background: "#F4F4F5", color: "#0A0A0A", borderColor: "#E4E4E7" }}>{a.action}</span>
                </td>
                <td className="px-4 py-3 text-xs font-mono">{a.entity_type}</td>
                <td className="px-4 py-3 text-sm">{a.description}</td>
              </tr>
            ))}
            {items.length === 0 && (<tr><td colSpan={5} className="py-8 text-center text-xs text-zinc-500">No activity.</td></tr>)}
          </tbody>
        </table>
      </div>
    </div>
  );
}
